export const DEFAULT_LOYALTY_PROGRAM_TERMINOLOGY = {
    singular: 'point',
    plural: 'points',
};
//# sourceMappingURL=defaults.js.map